import React from 'react';

import Layout from './Core/Layout';
import ScrollToTop from './Helpers/ScrollToTop';

const App = () => (
  <ScrollToTop>
    <Layout />
  </ScrollToTop>
);

export default App;
